import { Middleware } from '@nuxt/types';

const enforceReviewerRoleMiddleware: Middleware = context => {
  if (!context.$auth.$state.loggedIn) {
    // "auth" middleware will enforce this
    return;
  }

  const isUserReviewer = context.store.getters['settings/isReviewer'];
  if (!isUserReviewer) {
    const errorMessage = context.app.i18n.t('shared.error.server_validation.authorization_error');
    context.app.$toast.error(errorMessage);
    context.$auth.redirect('home');
  }
};

export default enforceReviewerRoleMiddleware;
